import type { components } from '@fluencelabs/vodopad-admin-api'
import { type TableColumnsType, Tag, Typography } from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'
import { MonoId } from '@/components/common/MonoId'
import { StatusTag } from '@/components/common/StatusTag'
import { UserEmailLink } from '@/components/common/UserEmailLink'
import { INTENT_STATUS_COLORS, PARK_REASON_LABELS } from '@/constants/payments'
import { formatUsdCents } from '@/utils/money'

import { ProviderMethod } from './components/ProviderMethod'

type AdminIntentDto = components['schemas']['AdminIntentDto']

export function intentColumns(): TableColumnsType<AdminIntentDto> {
  return [
    {
      title: 'Intent',
      dataIndex: 'intentId',
      key: 'intentId',
      width: 150,
      render: (id: string) => <MonoId id={id} />,
    },
    {
      title: 'User',
      dataIndex: 'userId',
      key: 'userId',
      width: 220,
      ellipsis: true,
      render: (id: string) => (id ? <UserEmailLink userId={id} /> : '—'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 130,
      render: (s: string) => (
        <StatusTag status={s} colorMap={INTENT_STATUS_COLORS} />
      ),
    },
    {
      title: 'Requested',
      dataIndex: 'requestedAmountCents',
      key: 'requestedAmountCents',
      width: 110,
      align: 'right',
      render: (c: number) => formatUsdCents(c),
    },
    {
      title: 'Claimed',
      dataIndex: 'claimedAmountCents',
      key: 'claimedAmountCents',
      width: 110,
      align: 'right',
      render: (c: number | null) =>
        c === null || c === undefined ? (
          <Typography.Text type="secondary">—</Typography.Text>
        ) : (
          formatUsdCents(c)
        ),
    },
    {
      title: 'Provider',
      key: 'provider',
      width: 160,
      render: (_: unknown, r: AdminIntentDto) => (
        <ProviderMethod provider={r.provider} methodCode={r.methodCode} />
      ),
    },
    {
      title: 'Park reason',
      dataIndex: 'parkReason',
      key: 'parkReason',
      width: 200,
      render: (reason: keyof typeof PARK_REASON_LABELS | null) =>
        reason ? <Tag color="warning">{PARK_REASON_LABELS[reason]}</Tag> : '—',
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (d: string) => <FormattedDate date={d} fmt="PPp" />,
    },
  ]
}
